import { Checkbox } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { addOrUpdateSupplierDeliveryType } from 'lib/firebase';
import { useState } from 'react';
import { SupplierDeliveryType } from 'types';

export interface WillCallCellProps {
    supplierId: string;
    params: GridRenderCellParams;
    onWillCallUpdate: (updatedDeliveryType: SupplierDeliveryType) => void;
}
export const WillCallCell = ({
    params,
    onWillCallUpdate,
    supplierId,
}: WillCallCellProps) => {
    const [checked, setChecked] = useState(params.row.willCall);

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);

        addOrUpdateSupplierDeliveryType(
            supplierId,
            params.row.deliveryTypeName,
            event.target.checked
        ).then(() => {
            onWillCallUpdate({
                deliveryTypeName: params.row.deliveryTypeName,
                willCall: event.target.checked,
            });
        });
    };

    return (
        <div data-testid="WillCallCell">
            <Checkbox checked={checked} onChange={onChange} />
        </div>
    );
};
